import React, { FC } from "react";
import { CustomModal } from "./Common/Modal/CustomModal";

interface SessionExpireProps {
    show: boolean;
}

const SessionExpire: FC<SessionExpireProps> = props => {
    const onCloseModal = (): void => {
        window.location.reload();
    };

    return (
        <CustomModal 
            className="confirm-modal-container" 
            show={props.show} 
            hideFooter={true}
            title="Security"
            isConfirmModal={true}
            onHide={onCloseModal}>
            <div>
                <h2>Session Expired</h2>
                <p>Your session has expired. Please login again.</p>
            </div>
        </CustomModal>
    );
};

export default SessionExpire;
